(function($) {
	'use strict';

	$(document).ready(function() {
		$(document).on('click', '.home-projects-slider .slick-next.mobile', function()  {
			var nextSlideIndex = parseInt($(this).parents('.slick-slide').next().data('slick-index'));
			$('.home-projects-slider').slick('slickGoTo', nextSlideIndex);
		});

		$(document).on('click', '.home-projects-slider .slick-prev.mobile', function()  {
			var nextSlideIndex = parseInt($(this).parents('.slick-slide').prev().data('slick-index'));
			$('.home-projects-slider').slick('slickGoTo', nextSlideIndex);
		});

		$('.hero-slider').slick({
			dots: true,
			arrows: false
		});

		$('.home-projects-slider').slick({
			dots: false,
			arrows: true,
			appendArrows: $('.home-projects-slider'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						appendArrows: $('.project-slide.arrows'),
						prevArrow: '<button class="slick-prev mobile" aria-label="Previous" type="button">Previous</button>',
						nextArrow: '<button class="slick-next mobile" aria-label="Next" type="button">Next</button>'
					}
				}
			]
		});

		$('.project-images-slider').slick({
			dots: true,
			arrows: true
		});

		$('.operations-slider').slick({
			dots: false,
			arrows: true,
			mobileFirst: true,
			centerMode: false,
			slidesToShow: 1,
			responsive: [
				{
					breakpoint: 599,
					settings: {
						slidesToShow: 1,
						centerMode: true,
						variableWidth: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						centerMode: true,
						variableWidth: true
					}
				},
				{
					breakpoint: 1279,
					settings: {
						slidesToShow: 4,
						centerMode: true,
						variableWidth: true
					}
				}
			]
		});
	});
})(jQuery);
